<button
  procure-button
  variant="ghost"
  color="white"
  animateBadgeChange
  matTooltip="Notifications"
  [badge]="count()"
  [matMenuTriggerFor]="inbox"
>
  <mat-icon>notifications</mat-icon>
</button>
<mat-menu
  #inbox
  class="inbox-panel"
  backdropClass="backdrop"
>
  <procure-loading-indicator [active]="isLoading()" />
  <div class="header">
    <div class="title">Notifications</div>
    <procure-input-switch
      class="switch"
      labelPosition="before"
      [control]="unreadOnly"
      (click)="$event.stopPropagation()"
    >
      Only show unread
    </procure-input-switch>
    @if (notifications().length) {
      <button
        procure-button
        variant="ghost"
        color="black"
        matTooltip="Mark all as read"
        (click)="markAllAsRead($event)"
      >
        <mat-icon>done_all</mat-icon>
      </button>
    }
    <a
      procure-button
      variant="ghost"
      color="black"
      matTooltip="Show more"
      [routerLink]="['/notifications']"
    >
      <mat-icon>visibility</mat-icon>
    </a>
  </div>
  @if (!notifications().length) {
    <div class="empty">You have no{{ unreadOnly.value ? " unread " : " " }}notifications.</div>
  }
  @for (message of notifications(); track message.id) {
    <div
      class="item"
      mat-menu-item
      (click)="toggleRead($event, message, false)"
    >
      <procure-notification-message
        class="message"
        condensed
        [message]="message"
        (toggleRead)="toggleRead($event, message, true)"
        (toggleArchive)="toggleArchive($event, message)"
      />
    </div>
  }
  @if (hasMore()) {
    <div
      class="item"
      (click)="$event.stopPropagation()"
    >
      <button
        class="display-more-button"
        procure-button
        variant="stroked"
        (click)="displayMore($event)"
      >
        Display more
      </button>
    </div>
  }
</mat-menu>
